


























import { Vue, Component, Prop } from 'vue-property-decorator'
import PromptModel from '@/models/investigation/promptModel'
import { getModule } from 'vuex-module-decorators'
import ExtensionModule from '@/store/extensionModule'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'

const extensionModule = getModule(ExtensionModule)

@Component
export default class SuggestedAction extends Vue {
  @Prop(String) readonly id!: string

  private prompts: Array<PromptModel> = []

  async created(): Promise<void> {
    await this.getPrompts()
  }

  private async getPrompts(): Promise<void> {
    this.prompts = await ApiService.getAllById<PromptModel>(
      UrlType.ExtensionPromptByRootCause,
      this.id + '/' + extensionModule.getExtensionId
    )
  }

  private getPromptIcon(promptCategory: string): string {
    switch (promptCategory) {
      case 'ESP':
        return 'mdi-wrench'
      case 'HB':
        return 'mdi-account'
      case 'ORG':
        return 'mdi-domain'
      default:
        return ''
    }
  }
}
